import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/history/layer.history.count.query.gql"
import type {
  LayerHistoryCountQuery,
  LayerHistoryCountQueryVariables,
} from "@/v2-backoffice-client/layer/history/__types__/layer.history.count.query"

type Options = QueryHookOptions<
  LayerHistoryCountQuery,
  LayerHistoryCountQueryVariables
>

export function useLayerHistoryCountQuery(options?: Options) {
  return useQuery<LayerHistoryCountQuery, LayerHistoryCountQueryVariables>(
    query,
    options,
  )
}
